import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const SiteCtx = createContext(null);

export const SiteProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await http.get("/site");
      setData(data);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh]);

  return <SiteCtx.Provider value={{ settings: data?.settings, campaign: data?.campaign, refresh }}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);

export const usePublic = (coll) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    http.get(`/public/${coll}`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [coll]);
  return items;
};
